// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"99b938ff","261":"99b938ff"}[chunkId] + ".chunk.css";
};